import React from 'react';
import { useGetIndependentIraUsersMetrics } from 'hooks/api/independentIra/useGetIndependentIraUsersMetrics';
import MetricItem from 'components/MetricCard';
import SearchBar from 'components/SearchBar';

import messages from './IndependentIraAccountsMetrics.messages';
import styles from './IndependentIraAccountsMetrics.module.css';

const IndependentIraAccountsMetrics: React.FC = () => {
  const { data: independentIraUsers, isLoading } = useGetIndependentIraUsersMetrics();

  const {
    totalProfileBalance,
    userIraCount,
    totalOrderFeeAmount,
    totalCustodyFeeAmount,
    totalWithdrawalFeeAmount,
  } = independentIraUsers ?? {};

  return (
    <div className={styles.container}>
      <div className={styles.metricsWrapper}>
        <MetricItem
          label={messages.totalProfileBalance}
          amount={totalProfileBalance}
          isLoading={isLoading}
        />
        <MetricItem
          label={messages.userIraCount}
          amount={userIraCount}
          isLoading={isLoading}
          isUsd={false}
        />
        <MetricItem
          label={messages.totalOrderFeeAmount}
          amount={totalOrderFeeAmount}
          isLoading={isLoading}
        />
        <MetricItem
          label={messages.totalCustodyFeeAmount}
          amount={totalCustodyFeeAmount}
          isLoading={isLoading}
        />
        <MetricItem
          label={messages.withdrawalFeesPaid}
          amount={totalWithdrawalFeeAmount}
          isLoading={isLoading}
        />
      </div>
      <div className={styles.searchBarWrapper}>
        <SearchBar isDisabled={isLoading} />
      </div>
    </div>
  );
};

export default IndependentIraAccountsMetrics;
